import { tokenPocket, tokenPocketDark } from "../../../utils";
export default {
  product: {
    title: '产品',
    label_1: 'KeyPal',
    label_2: '助记词密盒',
    label_3: '皮革保护套',
    label_4: '所有产品',
  },
  upgrade: {
    label_1: '升级',
  },
  // learn标题下面的描述我不知道是什么文案
  learn: {
    label_1: '安全',
  },
  others: {
    title: '其他',
    label_1: '关于',
    label_2: '隐私协议',
    label_3: '使用条款',
  },
  support: {
    title: '支持',
    label_1: '帮助中心',
    label_2: '购买问答',
    label_3: '社区',
  },
  cryptoAssets: {
    title: '加密资产',
    label_1: '比特币钱包',
    label_2: '以太坊钱包',
    label_3: 'Solana 钱包',
    label_4: 'Tron 钱包',
    label_5: '稳定币钱包',
  }, 
  getStarted: {
    title: '开始使用',
    label_1: '如何确保你的钱包安全？',
    label_2: '如何使用 KeyPal 2？',
    label_3: '如何使用 KeyPal Card？',
    label_4: '如何使用 KeyPal Plus？',
    label_5: '如何使用 Secret Box？',
  }, 
  download: {
    title: '下载',
    label_1: '移动钱包',
    label_2: '插件钱包',
    label_3: '升级',
  }, 
  legal: {
    title: '政策',
    label_1: '隐私政策',
    label_2: '使用条款',
  }, 

  designed: `由 ${tokenPocket} 设计 ❤️`,
  designedDark: `由 ${tokenPocketDark} 设计 ❤️`
};
